import {Drawer, DrawerSection} from '@yandex-delivery/blocks/legacy'
import React from 'react'

import Content from '../../Content'
import type {Props} from './types'

export function ModalMobile({onClose, contentSections}: Props): React.ReactElement<Props> {
  return (
    <Drawer onClose={onClose}>
      <DrawerSection>
        <Content sections={contentSections} />
      </DrawerSection>
    </Drawer>
  )
}
